import { Return } from "@redotech/redo-model/return";
import QrCode from "@redotech/redo-web/arbiter-icon/qr-code-01.svg";
import {
  Button,
  ButtonBorder,
  ButtonSize,
  ButtonTheme,
} from "@redotech/redo-web/button";
import LocationPin from "@redotech/redo-web/icon-old/location-pin.svg";
import { useState } from "react";
import { openUrl } from ".";
import * as returnStatus from "./return-status.module.css";

export const HappyReturnsButtons = ({
  happyReturnsData,
  zipCode,
}: {
  happyReturnsData?: Return["happyReturnsData"];
  zipCode: string | undefined | null;
}) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <div className={returnStatus.stepButtons}>
        {happyReturnsData?.qrCode && (
          <Button
            border={ButtonBorder.LIGHT}
            onClick={() => setShow(!show)}
            size={ButtonSize.MICRO}
            theme={ButtonTheme.OUTLINED}
          >
            <QrCode className={returnStatus.buttonIcon} /> Open QR Code
          </Button>
        )}
        {happyReturnsData?.retailerId && zipCode && (
          <Button
            border={ButtonBorder.LIGHT}
            onClick={() =>
              openUrl(
                `https://locations.happyreturns.com/?address=${zipCode}&has_qr_code=true&retailer=${happyReturnsData.retailerId}`,
              )
            }
            size={ButtonSize.MICRO}
            theme={ButtonTheme.OUTLINED}
          >
            <LocationPin className={returnStatus.buttonIcon} /> View locations
          </Button>
        )}
      </div>
      {show ? (
        <div className={returnStatus.happyReturnsQrCode}>
          {/* @ts-expect-error: strict-null-checks */}
          <img src={happyReturnsData.qrCode} />
          <span>{happyReturnsData?.rmaId}</span>
        </div>
      ) : undefined}
    </>
  );
};
